import React from "react";
import {
  HiOutlineArrowDownTray,
  HiOutlineArrowUpTray,
  HiOutlineArrowsRightLeft,
  HiOutlineWallet,
} from "react-icons/hi2";

const ICONS = {
  download: HiOutlineArrowDownTray,
  upload: HiOutlineArrowUpTray,
  credits: HiOutlineArrowsRightLeft,
  wallet: HiOutlineWallet,
};

const ACCENTS = {
  download: {
    border: "border-blue-200",
    bar: "bg-blue-500",
    iconBg: "bg-blue-500",
    cardBg: "bg-gradient-to-br from-blue-50 to-white",
  },
  upload: {
    border: "border-emerald-200",
    bar: "bg-emerald-500",
    iconBg: "bg-emerald-500",
    cardBg: "bg-gradient-to-br from-emerald-50 to-white",
  },
  credits: {
    border: "border-violet-200",
    bar: "bg-violet-500",
    iconBg: "bg-violet-500",
    cardBg: "bg-gradient-to-br from-violet-50 to-white",
  },
  wallet: {
    border: "border-amber-200",
    bar: "bg-amber-500",
    iconBg: "bg-amber-500",
    cardBg: "bg-gradient-to-br from-amber-50 to-white",
  },
};

const StatCard = ({ label, displayValue, icon }) => {
  const Icon = ICONS[icon] || HiOutlineWallet;
  const accent = ACCENTS[icon] || ACCENTS.wallet;

  return (
    <div
      className={`relative overflow-hidden rounded-2xl border ${accent.border} ${accent.cardBg} shadow-sm hover:shadow-lg transition-shadow duration-200 px-6 pt-6 pb-7 flex-1 min-w-220`}
    >
      <span className={`absolute inset-x-0 top-0 h-1.5 ${accent.bar}`} aria-hidden="true" />

      <div className="flex items-start justify-between">
        <span className="text-sm font-bold text-gray-600 uppercase tracking-wide">
          {label}
        </span>
        <span
          className={`w-10 h-10 rounded-xl ${accent.iconBg} flex items-center justify-center text-white shadow-md flex-shrink-0`}
        >
          <Icon size={19} aria-hidden="true" />
        </span>
      </div>

      <div className="mt-4 text-42 font-bold text-gray-900 tracking-tight">
        {displayValue}
      </div>
    </div>
  );
};

export default StatCard;
